import { Types } from "../constants/score-types";

const initialState = {
    easiHeadScores: undefined,
    easiTotal:undefined,
    globalAssessment:undefined,
    saveGlobalAssessment:undefined,
    pasiScoreNih: undefined,
    flareEasiScores: undefined,
    flarePasEasScores: undefined,
};

export default function easiScoreReducer(state = initialState, action) {
    switch (action.type) {
        case Types.SAVE_EASI_HEAD_SCORE:
            return { ...state, easiHeadScores: action.payload };
        case Types.GET_EASI_TOTAL:
            return { ...state, easiTotal: action.payload };
        case Types.GET_GLOBAL_ASSESSMENT:
            return { ...state, globalAssessment: action.payload };
        case Types.SAVE_GLOBAL_ASSESSMENT:
            return { ...state, saveGlobalAssessment: action.payload };
        case Types.PASI_SCORE_NIH:
            return { ...state, pasiScoreNih: action.payload };
        case Types.FLARE_EAS_PASI_SCORES:
            return { ...state, flarePasEasScores: action.payload };
        case Types.FLARE_EASI_SCORE:
            return { ...state, flareEasiScores: action.payload };
        default:
            return state;
    }
}
